import { makeStyles, Skeleton, SkeletonItem, Title2 } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    featuredPartnersContainer: {
        display: "flex",
        flexWrap: "wrap",
        maxWidth: "100%",
        padding: "0 0 32px 0",
        justifyContent: "center",
        backgroundColor: dolphinTokens.colorDarkBlue,
        color: "white",
    },
    featuredSkeletons: {
        display: "flex",
        width: "100%",
        height: "150px",
        marginBottom: "32px",
    },
    featuredSkeleton: {
        display: "block",
        width: "80%",
        height: "100%",
        margin: "0 auto"
    },
    otherPartnersTitle: {
        width: "100%",
        textAlign: "center"
    },
    partnersContainer: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: "16px",
        columnGap: "48px",
        padding: "32px",
        maxWidth: "100%",
        margin: "0 auto",
        justifyContent: "center",

        "@media (min-width: 768px)": {
            maxWidth: "1200px"
        }
    },
    skeletons: {
        display: "flex",
        width: "350px",
        height: "400px",
    },
    skeleton: {
        display: "block",
        width: "100%",
        height: "100%",
    }
});

export const FeaturedPartnerPlaceholder = () => {
    const { t } = useTranslation("partners");
    const styles = useStyles();

    return (
        <div className={styles.featuredPartnersContainer}>
            <Title2 block as="h2">
                {t("featuredPartners")}
            </Title2>
            <Skeleton className={styles.featuredSkeletons}>
                <SkeletonItem shape="rectangle" className={styles.featuredSkeleton} />
            </Skeleton>
            <Skeleton className={styles.featuredSkeletons}>
                <SkeletonItem shape="rectangle" className={styles.featuredSkeleton} />
            </Skeleton>
        </div>
    );
};

export const PartnerCardPlaceholder = () => {
    const { t } = useTranslation("partners");
    const styles = useStyles();

    return (
        <div>
            <Title2 block className={styles.otherPartnersTitle}>
                {t("otherPartners")}
            </Title2>

            <div className={styles.partnersContainer}>
                <Skeleton className={styles.skeletons}>
                    <SkeletonItem shape="rectangle" className={styles.skeleton} />
                </Skeleton>
                <Skeleton className={styles.skeletons}>
                    <SkeletonItem shape="rectangle" className={styles.skeleton} />
                </Skeleton>
                <Skeleton className={styles.skeletons}>
                    <SkeletonItem shape="rectangle" className={styles.skeleton} />
                </Skeleton>
            </div>
        </div>
    );
};